import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-white/10">
      <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-between sm:items-start">
        <div className="flex flex-wrap justify-center sm:justify-start gap-x-6 gap-y-2 text-sm text-gray-400 dark:text-gray-500">
          <Link to="/about">About</Link>
          <Link to="/how-it-works">How it works</Link>
          <Link to="/roadmap">Roadmap</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/employers/how-it-works">For employers</Link>
          <Link to="/employers/agency">For agencies</Link>
          {/* Semantic break: forces wrap between product and commercial clusters
              when the row doesn't fit, while staying invisible when it does. */}
          <span className="basis-full h-0" aria-hidden="true" />
          <Link to="/pricing">Pricing</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
        <p className="text-xs text-gray-400 dark:text-gray-600 text-center sm:text-right flex-shrink-0">
          © {new Date().getFullYear()} Joborigo. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
